import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/cba/address_tit.png';
import _imports_1 from '@assets/images/cba/basketball.png';
const _withScopeId = n => (_pushScopeId("data-v-bf4576ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cba-box"
};
const _hoisted_2 = {
  class: "top-box"
};
const _hoisted_3 = {
  class: "nft-list"
};
const _hoisted_4 = {
  class: "list"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0,
  class: "nft-btn-gray nft-btn-light"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "藏品合成", -1));
const _hoisted_9 = {
  key: 1,
  class: "nft-btn-gray"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "藏品合成", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "未能集齐6张队徽，不能进行藏品合成", -1));
const _hoisted_12 = [_hoisted_10, _hoisted_11];
const _hoisted_13 = {
  key: 2,
  class: "nft-btn-gray"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "藏品合成", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "活动已结束", -1));
const _hoisted_16 = [_hoisted_14, _hoisted_15];
const _hoisted_17 = {
  class: "merger-list"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "merger-item-r"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "tit"
}, "藏品合成成功", -1));
const _hoisted_21 = /*#__PURE__*/_createTextVNode("恭喜你抽中“");
const _hoisted_22 = {
  class: "prize"
};
const _hoisted_23 = /*#__PURE__*/_createTextVNode("”");
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "开奖倒计时：", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://p6.moimg.net/md/nft/119343CBA/cba02.jpg"
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://p6.moimg.net/md/nft/119343CBA/cba03.jpg"
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://p6.moimg.net/md/nft/119343CBA/cba04.jpg"
}, null, -1));
const _hoisted_31 = {
  class: "address-box"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tit",
  src: _imports_0
}, null, -1));
const _hoisted_33 = {
  class: "address-item"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "收件人", -1));
const _hoisted_35 = {
  class: "address-item"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "手机号", -1));
const _hoisted_37 = {
  class: "address-item"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "所在地区", -1));
const _hoisted_39 = {
  class: "address-item address-item-last"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "详细地址", -1));
const _hoisted_41 = {
  class: "address-box address-box-show"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tit",
  src: _imports_0
}, null, -1));
const _hoisted_43 = {
  class: "address-show-item"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "收件人", -1));
const _hoisted_45 = {
  class: "info"
};
const _hoisted_46 = {
  class: "address-show-item"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "手机号", -1));
const _hoisted_48 = {
  class: "info"
};
const _hoisted_49 = {
  class: "address-show-item"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "所在地区", -1));
const _hoisted_51 = {
  class: "info"
};
const _hoisted_52 = {
  class: "address-show-item"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "详细地址", -1));
const _hoisted_54 = {
  class: "info"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ball-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  height: "200",
  src: _imports_1
})], -1));
const _hoisted_56 = {
  class: "swipe-box",
  ref: "swipeBox"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swipe-item"
}, "“北京控股”熔解中...", -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swipe-item"
}, "“南京同曦宙光”熔解中...", -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swipe-item"
}, "“天津先行者球队”熔解中...", -1));
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swipe-item"
}, "“浙江稠州金租”熔解中...", -1));
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swipe-item"
}, "“山西汾酒股份”熔解中...", -1));
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swipe-item"
}, "“九台农商银行”熔解中...", -1));
const _hoisted_63 = {
  class: "swipe-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_picker = _resolveComponent("van-picker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nfts, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "nft-item nft-item-num"
    }, [_createElementVNode("img", {
      src: _ctx.$imgUrlFilter(item.img_url, 200 * $options.ratio)
    }, null, 8, _hoisted_5), _createElementVNode("span", null, _toDisplayString(item.title), 1), item.num > 0 ? (_openBlock(), _createElementBlock("i", _hoisted_6, _toDisplayString(item.num), 1)) : _createCommentVNode("", true)]);
  }), 128))]), $data.pro_status == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nft-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goToPro && $options.goToPro(...args))
  }, "收集队徽")) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", null, "合成即将开启 " + _toDisplayString($data.times_show), 1)])) : $data.status == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$data.isLogin ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nft-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goToLogin && $options.goToLogin(...args))
  }, "藏品合成")) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.is_merger ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nft-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goMerge && $options.goMerge(...args))
  }, "藏品合成")) : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))], 64))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))], 64))]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.merger_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "merger-item"
    }, [_createElementVNode("img", {
      src: item.img_url
    }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_hoisted_20, item.merge_type === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [$data.open_prize_status == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [item.prize_status == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", null, [_hoisted_21, _createElementVNode("span", _hoisted_22, _toDisplayString(item.prize_name), 1), _hoisted_23]), item.address_status == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "address-btn",
      onClick: $event => $options.showPopup(item.stock_hash)
    }, "查看收货地址", 8, _hoisted_24)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "address-btn",
      onClick: $event => $options.showPopupEdit(item.stock_hash)
    }, "填写收货地址", 8, _hoisted_25))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_26, "未中奖"))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_hoisted_27, _createElementVNode("div", null, _toDisplayString($data.time_seconds), 1)], 64))], 64)) : _createCommentVNode("", true)])]);
  }), 128))])]), _hoisted_28, _hoisted_29, _hoisted_30, _createVNode(_component_van_popup, {
    show: $data.showEdit,
    "onUpdate:show": _cache[10] || (_cache[10] = $event => $data.showEdit = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("i", {
      class: "address-close",
      onClick: _cache[3] || (_cache[3] = (...args) => $options.closePickerEdit && $options.closePickerEdit(...args))
    }), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createVNode(_component_van_field, {
      modelValue: $data.address_name,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.address_name = $event),
      placeholder: "请输入收件人"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createVNode(_component_van_field, {
      modelValue: $data.address_mobile,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.address_mobile = $event),
      placeholder: "请输入中国大陆手机号码"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_37, [_hoisted_38, _createVNode(_component_van_field, {
      modelValue: $data.address_obj,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.address_obj = $event),
      "is-link": "",
      readonly: "",
      placeholder: "省/市/区",
      onClick: _cache[7] || (_cache[7] = $event => $data.showPicker = true)
    }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _createVNode(_component_van_field, {
      modelValue: $data.address,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.address = $event),
      placeholder: "请输入详细地址"
    }, null, 8, ["modelValue"])]), _createElementVNode("div", {
      class: "address-add-btn",
      onClick: _cache[9] || (_cache[9] = (...args) => $options.addAddress && $options.addAddress(...args))
    }, "保存")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[12] || (_cache[12] = $event => $data.show = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("i", {
      class: "address-close",
      onClick: _cache[11] || (_cache[11] = (...args) => $options.closePicker && $options.closePicker(...args))
    }), _createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("div", _hoisted_45, _toDisplayString($data.address_info.address_name), 1)]), _createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, _toDisplayString($data.address_info.address_mobile), 1)]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, _toDisplayString($data.address_info.province) + _toDisplayString($data.address_info.city) + _toDisplayString($data.address_info.county), 1)]), _createElementVNode("div", _hoisted_52, [_hoisted_53, _createElementVNode("div", _hoisted_54, _toDisplayString($data.address_info.address), 1)])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showPicker,
    "onUpdate:show": _cache[14] || (_cache[14] = $event => $data.showPicker = $event),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: _ctx.addressList,
      "columns-field-names": $data.customFieldName,
      onCancel: _cache[13] || (_cache[13] = $event => $data.showPicker = false),
      onConfirm: $options.onConfirm
    }, null, 8, ["columns", "columns-field-names", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.loading
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "loading-box",
      onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
    }, [_hoisted_55, _createElementVNode("div", _hoisted_56, [_createElementVNode("div", {
      ref: "swipeInfo",
      class: _normalizeClass({
        'swipe-info': true,
        'swipe-info-animate': $data.ifAnimate
      })
    }, [_hoisted_57, _hoisted_58, _hoisted_59, _hoisted_60, _hoisted_61, _hoisted_62, _createElementVNode("div", _hoisted_63, "“CBA联盟队徽”合成中..." + _toDisplayString($data.loading_time) + "%", 1)], 2)], 512)])]),
    _: 1
  }, 8, ["show"])]);
}